import styled, { css } from 'styled-components';
import { SwiperSlide } from 'swiper/react';
/**
 * HorizontalScrollItemContainer
 */
export const horizontalScrollItemContainerStyles = () => css `
	box-sizing: border-box;
`;
export const HorizontalScrollItemContainer = styled(SwiperSlide) `
	${horizontalScrollItemContainerStyles}
`;
